module.exports = __webpack_public_path__ + "img/example.8af4438a.png";